import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PedidosMmaxEccomerce } from '../ecommerce-generico/interfaces/pedidos-eccomerce.interface';
import { HistorialPedidos } from '../ecommerce-generico/interfaces/historial-ecommerce-mmax';

@Injectable({
  providedIn: 'root'
})
export class PedidosService {

  private mypedido: PedidosMmaxEccomerce;
  private historiaPedidos: HistorialPedidos[] = [];
  private historialtemp: BehaviorSubject<HistorialPedidos[]> = new BehaviorSubject(this.historiaPedidos);
  private detalleElegido: HistorialPedidos;

  getUltimoPedido(): PedidosMmaxEccomerce {
    return this.mypedido;
  }

  setUltimoPedido(pedido: PedidosMmaxEccomerce): void {
    this.mypedido = pedido;
  }

  getHistorial(): HistorialPedidos[] {
    return this.historiaPedidos;
  }

  setHistorial(historial: HistorialPedidos[]): void {
    this.historiaPedidos = historial;
  }

  emitHistorialActual(): void {
    this.historialtemp.next(this.historiaPedidos);
  }

  getHistorialProvider(): Observable<HistorialPedidos[]> {
    return this.historialtemp.asObservable();
  }

  getDetalleElegido(): HistorialPedidos {
    return this.detalleElegido;
  }

  setDetalleElegido(detalle: HistorialPedidos): void {
    this.detalleElegido = detalle;
  }
}
